import { Box } from "@mui/material";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface LockedInputProps {
  value: string;
  width?: string;
}

const LockedInput: React.FC<LockedInputProps> = ({ value, width = '95%' }) => {
  return (
    <Box sx={{ position: 'relative', width }}>
      <input
        style={{
          height: '2.5rem',
          borderRadius: '0.3125rem',
          textAlign: 'right',
          border: '0.0625rem solid #f6f6f6',
          color: '#7e828b',
          backgroundColor: '#f6f6f6',
          paddingRight: '2rem',
          width: '100%',
        }}
        value={value}
        disabled
      />
      <LockOutlinedIcon
        style={{
          position: 'absolute',
          right: '0.5rem',
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#7e828b',
          pointerEvents: 'none',
          fontSize: '1.3rem',
        }}
      />
    </Box>
  );
};

export default LockedInput;